import API from "serviceshift-ui/api-client";

export default {
  createCalendarEvent(_, calendar_event) {
    return API.makeRequest("/admin/v4/calendar_events", {
      method: "POST",
      data: { calendar_event }
    });
  },
  updateCalendarEvent(_, calendar_event) {
    return API.makeRequest(`/admin/v4/calendar_events/${calendar_event.id}`, {
      method: "PUT",
      data: { calendar_event }
    });
  },
  deleteCalendarEvent(_, id) {
    return API.makeRequest(`/admin/v4/calendar_events/${id}`, {
      method: "DELETE"
    });
  },
  async fetchCalendarEvent(_, id) {
    const res = await API.makeRequest(`/admin/v4/calendar_events/${id}`, {
      method: "GET"
    });
    return res.data.calendar_event;
  }
};
